import React from 'react'
import { Link as ReactRouterLink } from 'react-router'
import { Button, Pane } from '@segment/react-ui-library'
import ActivitiesCard from './presentational/ActivitiesCard'
import UserCardLink from './presentational/UserCardLink'
import CardHeader from './presentational/CardHeader'
import UserCard from './presentational/UserCard'
import Events from './presentational/Events'
import Card from './presentational/Card'
import LinkedinIcon from './icons/linkedin'
import TwitterIcon from './icons/twitter'
import EmailIcon from './icons/email'
import ShowHide from 'ui/ShowHide'

const CustomersProfile = props => {
  const { workspaceSlug } = props
  const { properties, metadata, segmentId, aggregates, events } = props.user

  return (
    <div>
      <UserCard
        coordinates={{
          lat: properties.reveal_geo_lat,
          lng: properties.reveal_geo_lng
        }}
        lastSeen={metadata.updated_at}
        location={properties.location}
        company={properties.company}
        avatar={properties.avatar}
        name={properties.name}
        role={properties.role}
        id={segmentId}>
        <Pane display='flex' paddingX='24px' paddingY='12px'>
          <ShowHide show={properties.email}>
            <UserCardLink target='' href={`mailto:${properties.email}?Subject=Hello`} icon={<EmailIcon />}>{properties.email}</UserCardLink>
          </ShowHide>
          <ShowHide show={properties.twitter}>
            <UserCardLink href={`https://twitter.com/${properties.twitter}`} icon={<TwitterIcon />}>{properties.twitter}</UserCardLink>
          </ShowHide>
          <ShowHide show={properties.linkedin}>
            <UserCardLink href={`https://linkedin.com/${properties.linkedin}`} icon={<LinkedinIcon />}>{properties.linkedin}</UserCardLink>
          </ShowHide>
        </Pane>
      </UserCard>
      <ActivitiesCard events={aggregates.events} />
      <Card>
        <CardHeader title='Recent Events' alignItems='center'>
          <Button size='small' to={`/${workspaceSlug}/customers/profiles/${segmentId}/events`} is={ReactRouterLink}>All Events</Button>
        </CardHeader>
        <Events collapsible={false} events={events.slice(-5)} />
      </Card>
    </div>
  )
}

export default CustomersProfile



// WEBPACK FOOTER //
// ./components/Customers/CustomersProfileOverview.js